import { css } from '@emotion/core';
import { media, tokens, applyFont } from '@domain-group/fe-brary';
var colors = tokens.colors,
  typography = tokens.typography;
var _ref = {
  name: "1j2x37m",
  styles: "height:140px;"
};
export var content = (isHighlighted, results, fixedHeight) => /*#__PURE__*/css("width:100%;padding:12px;border-radius:3px;background:", isHighlighted ? colors.neutral.subdued.default : colors.neutral.background.default, ";border:", isHighlighted && results ? "1px solid ".concat(colors.neutral.trim.default) : 'none', ";margin-top:16px;", media('>=tablet'), "{", fixedHeight && _ref, " width:50%;flex:0 1 calc(50% - 8px);margin-top:0;}");
export var columns = {
  name: "t4gnko",
  styles: "display:flex;flex-direction:row;justify-content:space-between;margin-bottom:6px;"
};
export var title = /*#__PURE__*/css(applyFont(typography.overline), " color:", colors.neutral.medium.default, ";margin-bottom:4px;height:32px;");
export var column = {
  name: "2uchni",
  styles: "flex-grow:0;"
};
var _ref2 = {
  name: "1l7mgse",
  styles: "font-weight:normal;"
};
var _ref3 = {
  name: "1l7mgse",
  styles: "font-weight:normal;"
};
export var number = (isHighlighted, isBold) => /*#__PURE__*/css(applyFont(typography.heading), " ", !isBold && _ref2, " margin-bottom:4px;color:", isHighlighted ? colors.neutral.heavy.default : colors.neutral.medium.default, ";", media('>=tablet'), "{", !isBold && _ref3, "}");
export var text = /*#__PURE__*/css(applyFont(typography.body), " color:", colors.neutral.medium.default, ";");
export var count = /*#__PURE__*/css(applyFont(typography.miniBold));
export var secondary = /*#__PURE__*/css(applyFont(typography.mini), " color:", colors.neutral.medium.default, ";");